import { useEffect, useRef, useState } from 'react';
import BuffaloAvatar from './BuffaloAvatar';
const SANDY_RING = '#bfdbfe,#ddd6fe,#fbcfe8,#fde68a,#bbf7d0';

// The collapsed pill (Sandy 2026-08-07): the ONE bottom-right affordance that
// brings Sandy back after his panel is closed, shared by every host. A
// module-level roster makes sure two mounted hosts can never stack two pills.
const pillOwners = [];
export default function SandyPill({ onOpen }) {
  const idRef = useRef({});
  const [mine, setMine] = useState(false);
  useEffect(() => {
    const id = idRef.current;
    pillOwners.push(id);
    setMine(pillOwners[0] === id);
    return () => {
      const i = pillOwners.indexOf(id);
      if (i >= 0) pillOwners.splice(i, 1);
    };
  }, []);
  if (!mine) return null;
  return (
    <button
      type="button"
      onClick={onOpen}
      data-toast-above
      title="Open Buffy"
      className="tdv3-noprint fixed bottom-5 right-5 z-40 flex items-center gap-2.5 pl-2 pr-4 py-2 rounded-full bg-white shadow-[0_8px_28px_rgba(20,20,20,0.14)] hover:shadow-[0_10px_32px_rgba(20,20,20,0.18)] cursor-pointer transition-shadow"
      style={{
        border: '1.5px solid transparent',
        backgroundImage: `linear-gradient(white,white), linear-gradient(135deg,${SANDY_RING})`,
        backgroundOrigin: 'border-box',
        backgroundClip: 'padding-box, border-box',
      }}
    >
      <BuffaloAvatar size={38} />
      <span className="flex flex-col items-start leading-tight">
        <span className="text-[13px] font-extrabold text-ink">Buffy</span>
        <span className="text-[11px] text-neutral-500">Ask me anything</span>
      </span>
    </button>
  );
}
